var map = {
	"./logo-jyd.png": 34883,
	"./logo-mate.png": 75645,
	"./logo-pd.png": 84422,
	"./logo-rez.png": 16586,
	"./logo-xsg.png": 38297,
	"./logo-xyy.png": 47765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66996;